import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from 'gatsby-image';


const query = graphql`
    query {
        indexSpacer: dropboxNode(fields: {reference: {eq: "index_spacer"}}) {
            localFile {
                childImageSharp {
                    fluid(maxWidth: 1920, srcSetBreakpoints: [600, 960, 1280, 1920]) {
                    ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    }
`;

export const IndexSpacerMd = () => {
    const data = useStaticQuery(query);

    return <Img
        fluid={data.indexSpacer.localFile.childImageSharp.fluid}
        alt="Conference"
        style={{width: '100%', marginTop: '8vh', marginBottom: '8vh'}}
    />;
}